import { ApiError } from "@/modules/shared/utils/ApiError";

import { CoachAvailabilityResponse } from "../types/CoachAvailabilityResponse";

const UNPROCESSABLE_CONTENT = 422;

// A rejected range (e.g. past Glepnir's 93-day horizon) has no days to show and nothing to retry.
export const emptyOnRejectedRange = async (
  fetchAvailability: () => Promise<CoachAvailabilityResponse>,
): Promise<CoachAvailabilityResponse> => {
  try {
    return await fetchAvailability();
  } catch (error) {
    if (error instanceof ApiError && error.status === UNPROCESSABLE_CONTENT) {
      return [];
    }

    throw error;
  }
};
